/* Global navigation. Native links/details remain usable without JavaScript. */
(() => {
  document.documentElement.classList.remove('no-js');
  function init(root = document) {
    const header = root.querySelector('[data-global-header]');
    if (header && !header.dataset.ready) {
      header.dataset.ready = 'true';
      const nav = header.querySelector('[data-global-nav]');
      const toggle = header.querySelector('[data-nav-toggle]');
      const dropdowns = [...header.querySelectorAll('.global-nav__dropdown')];
      const mobile = matchMedia('(max-width:1040px)');
      const hover = matchMedia('(hover:hover) and (pointer:fine)');
      const controller = new AbortController();
      const timers = new Map();
      let frame;
      const cancelClose = d => { clearTimeout(timers.get(d)); timers.delete(d); };
      header._dispose = () => {
        controller.abort();
        dropdowns.forEach(cancelClose);
        cancelAnimationFrame(frame);
      };
      const options = {signal: controller.signal};
      const expanded = d => {
        const value = String(d.open);
        d.querySelector('summary').setAttribute('aria-expanded', value);
        d.closest('li').querySelector('.global-nav__link').setAttribute('aria-expanded', value);
      };
      const setOpen = (d, open) => {
        cancelClose(d);
        d.open = open;
        expanded(d);
      };
      const openDropdown = d => {
        dropdowns.forEach(other => setOpen(other, other === d));
      };
      const close = (restore = false) => {
        dropdowns.forEach(d => setOpen(d, false));
        if (mobile.matches) nav.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        if (restore && mobile.matches) toggle.focus();
      };
      const sync = () => {
        close();
        nav.hidden = mobile.matches;
      };
      mobile.addEventListener('change', sync, options); sync();
      toggle.addEventListener('click', () => {
        if (!nav.hidden) { close(); return; }
        nav.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
      }, options);
      dropdowns.forEach(d => {
        const item = d.closest('li');
        const link = item.querySelector('.global-nav__link');
        const summary = d.querySelector('summary');
        d.addEventListener('toggle', () => {
          expanded(d);
          if (d.open) dropdowns.forEach(other => { if (other !== d) setOpen(other, false); });
        }, options);
        item.addEventListener('pointerenter', e => {
          if (!mobile.matches && hover.matches && e.pointerType === 'mouse') openDropdown(d);
        }, options);
        item.addEventListener('pointerleave', e => {
          if (mobile.matches || e.pointerType !== 'mouse') return;
          cancelClose(d);
          // Bridge the small gap between the link and the absolutely positioned panel.
          timers.set(d, setTimeout(() => {
            timers.delete(d);
            if (!item.contains(document.activeElement)) setOpen(d, false);
          }, 140));
        }, options);
        item.addEventListener('focusout', e => {
          // On touch layouts, collapsing here can move the next summary before
          // the finger is released. Native activation closes the other panel.
          if (mobile.matches) return;
          if (e.relatedTarget) {
            if (!item.contains(e.relatedTarget)) setOpen(d, false);
            return;
          }
          // During native Tab navigation activeElement can briefly be <body>.
          // If the browser supplies no target, wait until that focus move finishes.
          cancelClose(d);
          timers.set(d, setTimeout(() => {
            timers.delete(d);
            if (!item.contains(document.activeElement)) setOpen(d, false);
          }, 0));
        }, options);
        [link, summary].forEach(trigger => trigger.addEventListener('keydown', e => {
          if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
          e.preventDefault();
          openDropdown(d);
          const cards = d.querySelectorAll('.global-nav__card');
          (e.key === 'ArrowUp' ? cards[cards.length - 1] : cards[0])?.focus();
        }, options));
      });
      header.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
          e.preventDefault();
          e.stopPropagation();
          const opened = dropdowns.find(d => d.open);
          if (opened) {
            setOpen(opened, false);
            (mobile.matches ? opened.querySelector('summary') : opened.closest('li').querySelector('.global-nav__link')).focus();
          } else close(true);
        }
      }, options);
      document.addEventListener('click', e => { if (!header.contains(e.target)) close(); }, options);
      document.addEventListener('shopify:block:select', e => {
        const item = e.target.closest('.global-nav__dropdown');
        if (item && header.contains(item)) {
          nav.hidden = false;
          toggle.setAttribute('aria-expanded', String(mobile.matches));
          openDropdown(item);
        }
      }, options);
      if (header.dataset.sticky === 'true' && document.body.classList.contains('template-index')) {
        const updateSticky = () => { frame = 0; header.classList.toggle('is-fixed', scrollY > 110); };
        window.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(updateSticky); }, {...options, passive:true});
        updateSticky();
      }
    }
    root.querySelectorAll('[data-announcement]').forEach(bar => {
      if (bar.dataset.ready) return;
      bar.dataset.ready = 'true';
      if (!window.Shopify?.designMode) { try {bar.hidden = sessionStorage.getItem('0086-announcement-dismissed') === '1';} catch (_) {} }
      document.body.classList.toggle('announcement-closed', bar.hidden);
      bar.querySelector('[data-announcement-close]')?.addEventListener('click', () => {bar.hidden = true;document.body.classList.add('announcement-closed');if (!window.Shopify?.designMode) {try {sessionStorage.setItem('0086-announcement-dismissed','1');} catch (_) {}}});
    });
  }
  init();
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:section:unload', e => e.target.querySelector('[data-global-header]')?._dispose?.());
})();
